export default __webpack_public_path__ + "static/media/Noo Saro-Wiwa premiata.60c5a466.jpg";